import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPen = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M23 13L27 17",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 28L11 29L12 24L27 9L31 13L16 28Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgPen);
export default ForwardRef;
